<div class="dob-picker" [class.dob-disabled]="disabled()" [class.dob-invalid]="touched() && (!selectedDay() || !selectedMonth() || !selectedYear())">
  <div class="dob-field">
    <label class="dob-label">{{ 'Day' | translate }}</label>
    <p-select
      [(ngModel)]="selectedDay"
      [options]="dayOptions()"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'Day' | translate"
      [disabled]="disabled()"
      (onBlur)="markTouched()"
      [style]="{ width: '100%' }"
      appendTo="body"
    ></p-select>
  </div>

  <div class="dob-field dob-field--month">
    <label class="dob-label">{{ 'Month' | translate }}</label>
    <p-select
      [(ngModel)]="selectedMonth"
      [options]="monthOptions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'Month' | translate"
      [disabled]="disabled()"
      (onBlur)="markTouched()"
      [style]="{ width: '100%' }"
      appendTo="body"
    ></p-select>
  </div>

  <div class="dob-field">
    <label class="dob-label">{{ 'Year' | translate }}</label>
    <p-select
      [(ngModel)]="selectedYear"
      [options]="yearOptions"
      optionLabel="label"
      optionValue="value"
      [placeholder]="'Year' | translate"
      [disabled]="disabled()"
      [filter]="true"
      filterPlaceholder=""
      (onBlur)="markTouched()"
      [style]="{ width: '100%' }"
      appendTo="body"
    ></p-select>
  </div>
</div>

@if (touched() && (!selectedDay() || !selectedMonth() || !selectedYear())) {
  <span class="dob-error">{{ 'Date of birth is required' | translate }}</span>
}
